import { defineStore } from "pinia";
import { fetchData } from "@/api/axiosHelper";


export const useCodeStore = defineStore("codeStore", {
  state: () => ({
    paymentMethods: [], // 결제방법
    brands: [],//브랜드리스트
    hasFullBrandAccess: false, // 전체 브랜드 접근 권한 여부

    ourCompanys: [],    // 우리회사구분
    suppliers: [],      // 거래처
    suplierCategories:[],//거래처구분
    expenseCategories:[],  //비용구분코드
    // 디자인 코드
    designCodes: {
      C04: [], // 성별
      C05: [], // 제품종류
      C06: [], // 스타일
    },
    employees: [], // 직원목록 (디자이너 선택용)

  }),
  actions: {
    async fetchBrands() {
      try {
        const response = await fetchData("brands/my-brands/");
        this.brands = response.results || [];
        this.hasFullBrandAccess = response.has_full_access || false;
      } catch (error) {
        console.error('브랜드 목록 조회 실패:', error);
        this.brands = [];
        this.hasFullBrandAccess = false;
      }
    },


    async fetchPaymentMethods() {

      const response =  await fetchData("expense-paymethod/");
      this.paymentMethods = response.results || response || [];
    },
    async fetchOurCompanys() {

      const response =await fetchData("expense-company/");
      this.ourCompanys  = response.results || response || [];
    },
    async fetchSuppliers() {
      const  response = await fetchData("suppliers/");
      this.suppliers  = response.results || response || [];
    },

    async fetchExpenseCategories() {
      const response = await fetchData("expense-category/");
      this.expenseCategories  = response.results || response || [];

    },

    async fetchSupplierCategories() {
      const response = await fetchData("suppliercategory/");
      this.suplierCategories  = response.results || response || [];
    },

    async fetchDesignCodes() {
      try {
        const [c04, c05, c06] = await Promise.all([
          fetchData("design-codes/?category=C04"),
          fetchData("design-codes/?category=C05"),
          fetchData("design-codes/?category=C06"),
        ]);
        this.designCodes.C04 = c04.results || c04 || [];
        this.designCodes.C05 = c05.results || c05 || [];
        this.designCodes.C06 = c06.results || c06 || [];
      } catch (error) {
        console.error('디자인 코드 조회 실패:', error);
      }
    },

    async fetchEmployees() {
      try {
        const response = await fetchData("employees/");
        this.employees = response.results || response || [];
      } catch (error) {
        console.error('직원 목록 조회 실패:', error);
        this.employees = [];
      }
    },
  },

});


